import { useState, useEffect } from 'react';
import { DAV_APIS } from '../adapters';

let nationalParksData: any[] = [];

const useNationalParks = (refresh?: number | null) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [nationalParks, setNationalParks] = useState<any[]>([]);

  useEffect(() => {
    const fetchNationalParks = async () => {
      if (!navigator.onLine) return;
      if (nationalParksData.length > 0 && !refresh) {
        setNationalParks(nationalParksData);
        return;
      }
      setLoading(true);
      try {
        const res = await DAV_APIS.nationalPark.get.getAllNationalParks();
        setNationalParks(res.data.nationalParks);
        nationalParksData = res.data.nationalParks;
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    fetchNationalParks();
  }, [refresh]);

  return {
    loading,
    nationalParks,
  };
};

export default useNationalParks;
